// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2g95w","ranges":"BmiRanges_ranges__2gsc5"};